<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';
import MyLoadsMobileConnectEldBannerComponent from '@/components/myLoads/MyLoadsMobileConnectEldBannerComponent.vue';
import MyLoadsMobileComingSoonBannerComponent from '@/components/myLoads/MyLoadsMobileComingSoonBannerComponent.vue';
import { useScreenSize } from '@/composables/useScreenSize';
const { screenSize } = useScreenSize();
const isDesktop = computed(() => screenSize.value === 'desktop');
const store = useStore();
const user = computed(() => store.state.users?.currentUser);
const defaultWelcomeMessage =
  'Highway for Carriers is your secure gateway to trusted brokers and the right freight for your business.';
</script>

<template>
  <div
    class="flex w-full items-center justify-center gap-10 bg-dark-gray p-10 text-steel-900"
  >
    <div
      v-if="isDesktop"
      class="flex max-w-[500px] flex-1 flex-col items-start gap-1"
    >
      <div
        class="w-full max-w-[500px] text-3xl font-medium capitalize leading-[48px] tracking-tight text-steel-0"
      >
        {{
          `Welcome${user.first_name ? `, ${user.first_name.toLowerCase()}` : ''}!`
        }}
      </div>
      <div
        class="w-full max-w-[500px] text-center text-base font-normal leading-7 text-steel-0"
      >
        {{ defaultWelcomeMessage }}
      </div>
    </div>
    <MyLoadsMobileConnectEldBannerComponent
      container-class="w-[325px] h-[235px]"
    />
    <MyLoadsMobileComingSoonBannerComponent
      container-class="w-[325px] h-[235px]"
    />
  </div>
</template>

<style scoped></style>
